import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["track"];
import { useMemo, useState } from 'react';
import ExamLayout from './ExamLayout';
import ExamResumeScreen from './ExamResumeScreen';
import ExamRulesScreen from './ExamRulesScreen';
import ExamFinishedScreen from './ExamFinishedScreen';
import ExamQuestionScreen from './ExamQuestionScreen';
import ExamAccessIssueScreen from './ExamAccessIssueScreen';
import { useExamRulesState, withExamContextProvider } from '../examsStores';
import { getCanDoAllTrackPracticalExercises, getMostRecentExamAttempt, getTrackPracticalExercises } from '../examsUtils';
import ExamLinkedLanguage from './ExamLinkedLanguage';
import { jsx as _jsx } from "react/jsx-runtime";
const Exam = ({
  track,
  trackProgress
}) => {
  const {
    id: trackId,
    language,
    exam,
    lessons,
    name
  } = track;
  const {
    showExamRules
  } = useExamRulesState();
  const {
    trackIdAward,
    trackAwardLanguage
  } = (trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.trackAward) || {};
  const certificationAwardedInDifferentLanguage = trackIdAward && trackIdAward !== trackId;
  const mostRecentExamAttempt = exam && getMostRecentExamAttempt(exam.id, trackProgress);
  const mostRecentExamAttemptOrNull = mostRecentExamAttempt || null;
  const trackPracticalExercises = getTrackPracticalExercises(lessons);
  const canDoAllTrackPracticalExercises = getCanDoAllTrackPracticalExercises(trackPracticalExercises);
  const pendingPracticalExercises = useMemo(() => {
    if (!trackPracticalExercises || !trackProgress) return null;
    if (trackProgress.status === 'COMPLETED' || trackProgress.status === 'EXPIRING_SOON') {
      return [];
    }
    return trackPracticalExercises.filter(exercise => {
      if (!exercise.parentLesson.graded || !exercise.graded) {
        return false;
      }
      const lessonProgress = trackProgress.progress.find(lp => lp.lessonId === exercise.parentLesson.id);
      const isCompleted = lessonProgress === null || lessonProgress === void 0 ? void 0 : lessonProgress.contentProgress.some(cp => cp.contentId === exercise.id && cp.progressType === 'COMPLETED');
      return !isCompleted;
    });
  }, [trackPracticalExercises, trackProgress]);
  const [examStartedAt, setExamStartedAt] = useState(null);
  if (!canDoAllTrackPracticalExercises) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamAccessIssueScreen, {})
    });
  }
  const examNotCompletedInAnyLanguage = !mostRecentExamAttempt && !certificationAwardedInDifferentLanguage;
  if (examNotCompletedInAnyLanguage || showExamRules) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamRulesScreen, {
        onExamStart: () => setExamStartedAt(new Date().getTime()),
        track: track,
        trackId: trackId
      })
    });
  }
  const hasResumeableExam = mostRecentExamAttempt && (mostRecentExamAttempt === null || mostRecentExamAttempt === void 0 ? void 0 : mostRecentExamAttempt.attemptFinishTime) == null;
  if (trackIdAward && trackAwardLanguage && certificationAwardedInDifferentLanguage && !examStartedAt && !hasResumeableExam) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamLinkedLanguage, {
        award: (trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.trackAward) || undefined,
        language: language,
        linkedLanguage: trackAwardLanguage,
        mostRecentExamAttempt: mostRecentExamAttempt || null,
        trackId: trackId,
        trackName: name
      })
    });
  }
  const attemptFinished = (mostRecentExamAttempt === null || mostRecentExamAttempt === void 0 ? void 0 : mostRecentExamAttempt.attemptFinishTime) != null;
  if (mostRecentExamAttempt && attemptFinished) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamFinishedScreen, {
        award: (trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.trackAward) || undefined,
        certificationAwardedInDifferentLanguage: !!certificationAwardedInDifferentLanguage,
        mostRecentExamAttempt: mostRecentExamAttempt,
        pendingPracticalExercises: pendingPracticalExercises,
        track: track
      })
    });
  }
  if (mostRecentExamAttempt && !mostRecentExamAttempt.questions.length) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamResumeScreen, {
        mostRecentExamAttempt: mostRecentExamAttemptOrNull,
        track: track
      })
    });
  }
  return /*#__PURE__*/_jsx(ExamLayout, {
    children: /*#__PURE__*/_jsx(ExamQuestionScreen, {
      clientStartTime: examStartedAt,
      mostRecentExamAttempt: mostRecentExamAttemptOrNull,
      track: track
    })
  });
};
const ExamContent = _ref => {
  let {
      track
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return track ? /*#__PURE__*/_jsx(Exam, Object.assign({
    track: track
  }, props)) : null;
};
export default withExamContextProvider(ExamContent);